import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api';

export default function Forgot() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [resetUrl, setResetUrl] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await api.forgot(email);
      setSubmitted(true);
      if (res.resetUrl) setResetUrl(`${window.location.origin}${res.resetUrl}`);
    } finally { setBusy(false); }
  }

  return (
    <div className="auth-split">
      <div className="auth-left">
        <div className="auth-card">
          <div className="auth-brand"><Link to="/">Rivet</Link></div>
          <h1>Reset password</h1>
          {submitted ? (
            <>
              <p className="muted">If that email exists in our system, a reset link was issued.</p>
              {resetUrl && (
                <div className="banner review">
                  <span>🔑</span>
                  <div>Phase 1 — no email server. Use this link:<br /><code style={{ fontSize: 11, wordBreak: 'break-all' }}>{resetUrl}</code></div>
                </div>
              )}
              <div className="auth-footer"><Link to="/login">← Back to sign in</Link></div>
            </>
          ) : (
            <>
              <p className="muted">Enter your email. We'll send you a reset link.</p>
              <form onSubmit={submit}>
                <label className="field"><span className="label">Email</span>
                  <input className="input" autoFocus type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                </label>
                <button className="btn" style={{ width: '100%' }} disabled={busy || !email}>{busy ? 'Sending…' : 'Send reset link'}</button>
              </form>
              <div className="auth-footer"><Link to="/login">← Back to sign in</Link></div>
            </>
          )}
        </div>
      </div>
      <div className="auth-right" style={{ backgroundImage: `linear-gradient(135deg, rgba(24,29,76,0.6), rgba(24,29,76,0.4))` }}>
        <div className="auth-right-inner"><div className="kicker light">Rivet</div><h2>Get back in.</h2></div>
      </div>
    </div>
  );
}
